var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCezannehr = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0175 42.8446L44.7585 39.5856L41.2748 36.1019C40.151 34.9781 38.2405 34.9781 37.1167 36.1019C34.9815 38.2371 32.6216 40.597 30.374 42.8446C25.5417 47.6769 25.5417 55.5435 30.374 60.3758C35.2063 65.2081 43.0728 65.2081 47.9051 60.3758C52.8498 55.5435 52.8498 47.6769 48.0175 42.8446Z",
    fill: "#B62648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.014 41.1589L48.0175 21.1554C52.8498 16.3231 52.8498 8.45654 48.0175 3.62423C43.1852 -1.20808 35.3187 -1.20808 30.4864 3.62423L19.2485 14.8622C9.58385 24.5268 9.58385 40.2599 19.2485 50.0368C21.0465 51.8349 22.7322 53.5206 24.1931 54.9815C22.957 49.0254 25.3169 43.856 28.014 41.1589Z",
    fill: "#AEB0B1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCezannehr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cezannehr.894d2e38be8d0e007f2db177572af5ac.svg";